import state from '@/store/module_alerta/state'
import mutations from '@/store/module_alerta/mutations'
import actions from '@/store/module_alerta/actions'

export default ({
  state,
  mutations,
  actions,
})